import { useEffect, useState } from 'react';
import { Layout } from '@/components/Layout';
import { api } from '@/lib/api';
import { useSEO } from '@/lib/useSEO';
import { PromoOfferCard } from '@/components/PromoOfferCard';

export default function Promociones() {
  const [items, setItems] = useState(null);
  useSEO({
    title: 'Promociones | AutoMarket Colombia',
    description: 'Promociones, servicios y ofertas especiales de AutoMarket Colombia.',
    canonical: '/promociones',
  });
  useEffect(() => {
    api.get('/promo-offers?limit=50').then(({ data }) => setItems(data.items || [])).catch(() => setItems([]));
  }, []);
  return (
    <Layout>
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="promociones-page">
        <div className="text-xs font-bold uppercase tracking-[0.25em] text-orange-600">Ofertas</div>
        <h1 className="font-display text-4xl font-black tracking-tighter text-slate-900 sm:text-5xl">Promociones</h1>
        <p className="mt-2 text-sm text-slate-600 md:text-base">Servicios, productos y ofertas especiales publicadas por AutoMarket Colombia.</p>
        {items === null ? (
          <div className="mt-8 text-sm text-slate-500" data-testid="promociones-loading">Cargando…</div>
        ) : items.length === 0 ? (
          <div className="mt-8 border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500" data-testid="promociones-empty">
            No hay promociones vigentes en este momento.
          </div>
        ) : (
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="promociones-grid">
            {items.map((o) => <PromoOfferCard key={o.offer_id} offer={o} />)}
          </div>
        )}
      </div>
    </Layout>
  );
}
